import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "exchange-rates" }
const _hoisted_4 = {
  key: 0,
  class: "rates-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "rates-grid"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "currency-code" }
const _hoisted_8 = { class: "rate-value" }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = { class: "form-footer" }
const _hoisted_11 = { class: "switch-form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { class: "auth-form" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Добро пожаловать в МНОС!", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_divider, null, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "divider-text" }, "Курсы валют", -1)
              ])),
              _: 1
            }),
            (_ctx.loadingRates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_el_skeleton, {
                    rows: 2,
                    animated: ""
                  })
                ]))
              : (_ctx.exchangeRates.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.exchangeRates, (rate) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: rate.currency,
                        class: "rate-item"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getCurrencyFlagUrl(rate.currency),
                          alt: rate.currency,
                          class: "currency-flag"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(rate.currency), 1),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(rate.rate.toFixed(4)), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.isLogin ? 'Пожалуйста, войдите в аккаунт' : 'Пожалуйста, заполните данные для создания аккаунта'), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          "label-position": "top",
          onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "Email",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                  type: "email",
                  placeholder: "Введите ваш email",
                  "prefix-icon": _ctx.Message
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Пароль",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                  type: "password",
                  placeholder: "Введите ваш пароль",
                  "prefix-icon": _ctx.Lock,
                  "show-password": ""
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            (!_ctx.isLogin)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "Идентификатор менеджера",
                  prop: "sales_person_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.sales_person_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.sales_person_id) = $event)),
                      placeholder: "Выберете вашего менеджера",
                      class: "full-width",
                      loading: _ctx.loadingSalesPersons
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesPersons, (person) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: person.id,
                            label: person.id,
                            value: person.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  "native-type": "submit",
                  loading: _ctx.loading,
                  class: "submit-button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? 'Обработка...' : (_ctx.isLogin ? 'Вход' : 'Создать аккаунт')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "onSubmit"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_divider, null, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "divider-text" }, "or", -1)
            ])),
            _: 1
          }),
          _createElementVNode("p", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.isLogin ? "Нет аккаунта?" : "Уже есть аккаунт?") + " ", 1),
            _createVNode(_component_el_button, {
              link: "",
              onClick: _ctx.toggleLoginMode
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isLogin ? 'Создать аккаунт' : 'Вход'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}